<div class="rn-supervisor-notice" *ngIf="wantAppear && (rnSupervisorNoticeEnabled$ | async)">
    <div class="header">
        <mat-icon class="s-24">info</mat-icon>
        <b>RN Supervisor</b>
    </div>
    <span>
        If you need to fill a supervisor role, please request an RN Supervisor.
    </span>
</div>
